import { Component, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";

@Component({
  selector: "app-ketendiensten",
  templateUrl: "./ketendiensten.component.html",
  imports: [TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class KetendienstenComponent {}
